import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { showToasterMessage } from 'src/app/shared/actions/toaster.actions';
import { ToasterService } from 'src/app/shared/services/toaster.service';

@Injectable()
export class ToasterEffects {
    constructor(private readonly _actions$: Actions, private readonly _toasterService: ToasterService) {}

    showToasterMessage$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType(showToasterMessage),
                map((action) => this._toasterService.toast(action.message, action?.duration ?? 2000))
            ),
        { dispatch: false }
    );
}
